import { Checkbox, Chip, chipClasses } from '@mui/material';
import { ChangeEvent, ReactNode } from 'react';

interface IProps {
  checked?: boolean;
  labelIcon?: ReactNode;
  label: string;
  printPdfMode?: boolean;
  checkedForPrint?: boolean;
  onChange: (event: ChangeEvent<HTMLInputElement>, checked: boolean) => void;
  value: string;
}

const TypeChip = ({ checked, labelIcon, label, printPdfMode, checkedForPrint, onChange, value }: IProps) => {
  return (
    <Chip
      sx={{
        minWidth: 61,
        [`&.${chipClasses.outlined}`]: {
          color: '#2E2C34',
        },
        [`&.${chipClasses.filled}`]: {
          padding: '1px',
        },
      }}
      color={checked ? 'primary' : 'default'}
      variant={checked ? 'filled' : 'outlined'}
      label={
        <div className='flex items-center'>
          {labelIcon}
          <span className='text-[14px] font-[Manrope] font-semibold'>{label}</span>
          {printPdfMode && <Checkbox value={value} checked={checkedForPrint} onChange={onChange} />}
        </div>
      }
    />
  );
};

export default TypeChip;
